export type ChartMode = 'Billability' | 'Project';

export interface DonutSlice {
  id: string;
  label: string;
  color: string;
  totalSecs: number;
}

export const CHART_MODES: ChartMode[] = ['Billability', 'Project'];

export interface ReportFiltersState {
  userIds?: string[];
  clientIds?: string[];
  projectIds?: string[];
  billable?: boolean | null;
  hasDescription?: boolean;
  descriptionSearch?: string;
}

export type ReportTab = 'summary' | 'detailed' | 'weekly' | 'shared';

export interface SummaryRow {
  id: string;
  projectId?: string;
  clientId?: string;
  projectName: string;
  clientName: string;
  color: string;
  totalDurationSecs: number;
  billableDurationSecs: number;
  amountCents: number;
  entryCount: number;
  isBillable: boolean;
}